import { useEffect, useState } from 'react';

const COOKIE_NAME = 'darkMode';
const COOKIE_MAX_AGE_DAYS = 365;

function getCookie(name) {
  const match = document.cookie.match(
    new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)')
  );
  return match ? decodeURIComponent(match[1]) : null;
}

function setCookie(name, value) {
  const maxAge = COOKIE_MAX_AGE_DAYS * 24 * 60 * 60;
  const secure = window.location.protocol === 'https:' ? '; Secure' : '';
  document.cookie = `${name}=${encodeURIComponent(value)}; path=/; max-age=${maxAge}; SameSite=Lax${secure}`;
}

/**
 * Dark Mode Hook
 * Persists preference in a cookie so it survives logout (which clears localStorage).
 */
export function useDarkMode() {
  const [isDark, setIsDark] = useState(() => {
    const stored = getCookie(COOKIE_NAME);
    if (stored !== null) {
      return stored === 'true';
    }
    return window.matchMedia('(prefers-color-scheme: dark)').matches;
  });

  useEffect(() => {
    const root = document.documentElement;
    if (isDark) {
      root.classList.add('dark');
    } else {
      root.classList.remove('dark');
    }
    setCookie(COOKIE_NAME, isDark.toString());
  }, [isDark]);

  const toggle = () => setIsDark(!isDark);
  const enable = () => setIsDark(true);
  const disable = () => setIsDark(false);

  return { isDark, toggle, enable, disable };
}
